module.exports = __webpack_public_path__ + "static/img/2015.9370009.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2015.png
// module id = t1Sj
// module chunks = 1